// Pop Market community forum — rolling feed of orders + freeform
// messages backed by pop_market_forum. Writes go through the
// popMarketPostForum callable (rate-limited server-side); reads are
// direct Firestore subscriptions capped at 100 messages.

import {
  collection, query, orderBy, limit, where, onSnapshot,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../firebase";

const FORUM_COL = "pop_market_forum";
export const FORUM_DEPTH = 100;

// Subscribe to the latest 100 messages for a game. `kindFilter` picks
// which tab is being shown ("order" | "message" | null for both).
// Returns an unsubscribe fn. Consumer receives an array sorted newest-
// first; empty array on error so the UI can still render a state.
export function subscribeForum({ game, kindFilter = null }, cb) {
  if (!game) { cb([]); return () => {}; }
  const clauses = [
    where("game", "==", game),
    where("status", "==", "active"),
  ];
  if (kindFilter) clauses.push(where("kind", "==", kindFilter));
  const q = query(
      collection(db, FORUM_COL),
      ...clauses,
      orderBy("createdAt", "desc"),
      limit(FORUM_DEPTH),
  );
  return onSnapshot(q,
      (snap) => cb(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
      (err) => {
        console.warn("[pop-market] subscribeForum failed", err);
        cb([]);
      },
  );
}

// Post an order (structured — quantity required, rate optional) or a
// freeform message. Server enforces auth + rate limit + validation.
// Payload:
//   { kind: "order" | "message",
//     game: "BGMI" | "PUBG",
//     quantity?: number,      // required for orders
//     segment?: "mix"|"premium"|"lumen"|"helicopter",  // defaults to mix
//     maxRate?: number,       // optional
//     text?: string }         // required for messages, optional for orders
export async function postForumMessage(payload) {
  const call = httpsCallable(functions, "popMarketPostForum");
  const res = await call(payload);
  return res.data;
}
